import React, { useState, useEffect } from "react";
import "./PathologyRecord.css";
import { useParams, useNavigate } from "react-router-dom";
import { useApp } from "./../../../../../AppProvider";

const RadiologyRecord = () => {
  const { patientsMHR } = useApp();
  const navigate = useNavigate();
  let { recordId } = useParams();

  if (recordId === undefined) {
    recordId = patientsMHR[0].recordId;
    navigate(`/DashboardDashboardNavigation/records/${recordId}`);
  }

  const record = patientsMHR.find((item) => item.recordId === recordId);
  const studyInstanceUID = record.studyInstanceUID

  // console.log("Record in RadiologyRecord:", record);

  return (
    <div className="card-container-main">
      <div className="card-container-records">

      </div>
      {studyInstanceUID && (
        <div className="dicom-container">
          <iframe
            className="dicom-viewer"
            src={`https://viewer.cohesivehealth.in/viewer?StudyInstanceUIDs=${studyInstanceUID}`}
            title="MRI Viewer"
            width="100%"
            height="800px"
            style={{ border: "none" }}
            allowFullScreen
          />
        </div>
      )}
    </div>
  );
};

export default RadiologyRecord;
